import React, { useEffect, useState } from 'react';
import {Route, Routes, useLocation } from 'react-router-dom';
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
import { MenuItem } from "components/interface";
import { API_ENDPOINTS } from 'components/Service/headerfooterApi';
type IconItem = {
  image: any;   // replace with actual type if known
  title: any;
};
const Header: React.FC = () => {
  const [menu, setMenu] = useState<MenuItem[]>([]);
  const [iconList, setIconList] = useState<IconItem[]>([]);
  const [img, setImg] = useState<any>(null);
  const location = useLocation();
  const path = location.pathname;
   const hideTopSelect =
    location.pathname === '/' ;
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const res = await fetch(API_ENDPOINTS.MENU_MAIN);
        const data = await res.json();

          const responce = await fetch(API_ENDPOINTS.Header);
          const logo = await responce.json();

          localStorage.setItem("siteKey", logo.data[0]?.attributes?.field_site_key);
     
          const included = logo.included || [];
          const relationships =logo.data[0].relationships;
          const getImageFromMedia = (mediaId?: string) => {
            if (!mediaId) return { url: null, alt: null };
        
            const media = included?.find(
              (inc: any) =>
                (inc.type === "media--image" || inc.type === "media--svg_image") &&
                inc.id === mediaId,
            );
        
            if (!media) return { url: null, alt: null };
        
            // handle both image and svg relationship fields
            const imageField =
              media.relationships?.field_media_image?.data ||
              media.relationships?.field_media_svg_image?.data;
        
            if (!imageField?.id) return { url: null, alt: null };
        
            const file = included?.find(
              (inc: any) => inc.type === "file--file" && inc.id === imageField.id,
            );
        
            const fileUrl = file?.attributes?.uri?.url
              ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
              : null;
        
            const altText = imageField?.meta?.alt || media?.attributes?.name || "";
        
            return {
              url: fileUrl,
              alt: altText,
            };
          };
          const featureImages = relationships.field_site_logo?.data?.id || [];
            const iconarray: any[] = [];

          relationships.field_icon_images?.data?.forEach((item: any, i: number) => {
            const image = getImageFromMedia(item.id);
            const title = logo.data[0]?.attributes?.field_icon_title?.[i];

            iconarray.push({
              image,
              title
            });
          });
        if(iconarray.length > 0){
          setIconList(iconarray);
        }
        
         // const iconImage = relationships.field_icon_images?.data?.id || [];
          setImg(getImageFromMedia(featureImages));
        const items: MenuItem[] = data.data.map((item: any) => ({
          id: item.id,
          title: item.attributes.title,
          
          url: item.attributes.url.startsWith("/hreplcmsweb") ? item.attributes.url.replace("/hreplcmsweb", "") : item.attributes.url,
          parent: item.attributes.parent || null,
        }));
        localStorage.setItem("menuItems", JSON.stringify(items));
        // Convert flat menu into tree
        const map: Record<string, MenuItem> = {};
        const roots: MenuItem[] = [];

        items.forEach((item) => (map[item.id] = { ...item, children: [] }));
        items.forEach((item) => {
          if (item.parent && map[item.parent]) {
            map[item.parent].children!.push(map[item.id]);
          } else {
            roots.push(map[item.id]);
          }
        });

        setMenu(roots);
      } catch (err) {
        console.error('Error fetching menu:', err);
      }
    };

      // Find current page
  // const currentPage = flatMenu.find(
  //   (item) => item.url === path
  // );

  // const pageData = {
  //   title: currentPage?.title || "Home",
  //   url: currentPage?.url || "/",
  // };

 // localStorage.setItem("currentPage", JSON.stringify(pageData));



    fetchMenu();
  }, []);

 // console.log(iconList);
  // Recursive menu renderer for dropdowns
  const renderMenu = (items: MenuItem[], isSub = false) => {
  return items.map((item) => {
    if( item.title != 'Home'){
      if (item.children && item.children.length > 0) {
        return (
          <div key={item.id} className={`nav-item dropdown ${isSub ? 'dropdown-submenu' : ''}`}>
            <a
              href={item.url || '#'}
              className={`nav-link dropdown-toggle ${path === item.url ? 'active' : '' }`}
              data-bs-toggle="dropdown"
            >
              {item.title}
            </a>

            <ul className="dropdown-menu">
              {renderMenu(item.children, true)}
            </ul>
          </div>
        );
      }
    }

    return isSub ? (
      <li key={item.id}>
        <a href={item.url || '#'} className={`dropdown-item ${path === item.url ? 'active' : '' }`}>
          {item.title}
        </a>
      </li>
    ) : (
      <a key={item.id} href={item.url || '#'} className={`nav-item nav-link ${path === item.url ? 'active' : '' }`} >
        {item.title}
      </a>
    );
  });
};

  return (
    <>
      {/* <!-- Navbar Start --> */}
      <nav id="fixed-top" className="navbar navbar-expand-lg bg-white navbar-light fixed-top p-0">
        <div className="container-xxl container-fluid ">
          <a  href="/"  className="navbar-brand d-flex align-items-center  pe-4 px-lg-3"  >
            <img src={img?.url || "../assets/img/logo/HREPL-Logo.svg"} alt={img?.alt || "logo"}
             
              className="logo-img" loading='lazy'
            />
          </a>
          <button
            type="button"
            className="navbar-toggler me-3"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
                <div className="navbar-nav ms-auto p-4 p-lg-0">
              {renderMenu(menu)}
            </div>
            <a
              href="#"
              className="rounded-0 py-4 px-lg-2 d-none d-lg-block"
            >
              <i className="fa fa-search ms-3"></i>
            </a>
          </div>
        </div>
      </nav>
            {hideTopSelect && iconList.length > 0 && (
          <div id="selector">
          

              <div id="demo-rtl" className="sc-opt bg-white">
                  <div className="sc-icon"><img src={iconList[0]?.image?.url} alt={iconList[0]?.image?.alt} className="img-fluid" /></div><span className="sc-val  py-2 text-primary"><a href={iconList[0]?.title?.uri.replace("internal:","")}>{iconList[0]?.title?.title}</a></span>
              </div>
              <div className="sc-opt sc-mt bg-white">
                  <div className="sc-icon"><img src={iconList[1]?.image?.url} alt={iconList[1]?.image?.alt} className="img-fluid" /></div><span className="sc-val text-black py-2"><a href={iconList[1]?.title?.uri.replace("internal:","")}>{iconList[1]?.title?.title}</a></span>
                  {/* <!--<span className="opt tc1" data-color="scheme-1"></span>
                  <span className="opt tc2" data-color="scheme-2"></span>
                  <span className="opt tc3" data-color="scheme-3"></span>--> */}
              </div>
          
            </div>
      )}
      {/* <!-- Navbar End --> */}
    </>
  );
};

export default Header;
